<template>
  <fb-form-body>
    <el-form :model="formData" :rules="rules" ref="form" label-width="140px" class="fb-form">

      <el-form-item :label="`${$t('lang.序号')}：`" prop="number">
        <el-select v-model="formData.number" :placeholder="$t('lang.请选择')">
          <el-option v-for="i in 30" :key="i" :label="i" :value="i"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="`${$t('lang.图片')}：`" prop="photo">
        <el-upload
            ref="uploadfiles"
            :action="api.upload"
            :limit="1"
            :on-change="handleUploadFile"
            :on-remove="handleRemoveFile"
            :data="{category: 'ADVERTISING'}"
            list-type="picture-card">
          <i class="el-icon-plus"></i>
        </el-upload>
        <span style="color: #ef0b5a">720*1280px</span>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSubmit('form')">{{ $t('lang.确定') }}</el-button>
        <el-button @click="handleReset('form')">{{ $t('lang.重置') }}</el-button>
      </el-form-item>
    </el-form>
  </fb-form-body>
</template>

<script>
export default {
  name: "LockScreenAdsAdd",
  components: {},
  data() {
    return {
      api: {
        add: this.$api.lockScreenAds.add,
        upload: this.$api.file.upload,
      },
      formErrorMsg: {account: ''},
      formData: {
        subBrandProductCode: this.$route.query.code,
        number: '',
        photo: ''
      },
    }

  },
  computed: {
    rules() {
      let checkPhoto = (rule, value, callback) => {
        if(!this.formData['photo']) {
          return callback(new Error(this.$t('lang.图片不能为空')))
        }
        return callback();
      };
      return {
        number: [
          {required: true, message: this.$t('lang.序号不能为空'), trigger: 'blur'}
        ],
        photo: [
          {required: true, validator: checkPhoto, trigger: 'blur'}
        ],

      }
    }
  },
  methods: {
    handleUploadFile(file) {
      const vm = this;
      if(file.percentage == 100) {
        let {response: res} = file;
        if(res.status != 200) {
          vm.$message.error(res.desc);
          return;
        }
        vm.formData['photo'] = res.data.fileCode;
        this.$refs.form.clearValidate('photo');
      }
      console.log('file', file)

    },
    handleRemoveFile() {
      // console.log('删除了图片');
      console.log(this.formData);
      this.formData['photo'] = '';
    },
    handleSubmit(form) {

      let vm = this;
      vm.$refs[form].validate((valid) => {
        if (valid) {

          this.formData.number = this.formData.number + ''

          vm.$http.post(vm.api.add, this.$qs.stringify(this.formData)).then((resp) => {

            if (resp.data.status === 200) {
              vm.$message({
                type: 'success',
                message: resp.data.desc
              });
              vm.$router.back();
            } else if (resp.data.status === 400) {
              if (resp.data.desc) {
                vm.$message({
                  type: "error",
                  message: resp.data.desc
                });
              }

            } else {
              vm.$message({
                type: "error",
                message: resp.data.desc
              })
            }

          });
          return true;
        } else {
          return false;
        }
      });

    }
    ,
    handleReset(form) {
      this.$refs.uploadfiles.clearFiles();
      this.$refs[form].resetFields();

      // console.log('this.formData,',this.formData);
    }
  }
  ,
  created() {
    // let vm = this;

  }
}
</script>

<style lang="scss" scoped>

.fb-form {
  max-width: 500px;
}

</style>
